<script>
export default {
  props: {
    number: {
      type: Number,
      default: 0,
    },
  },
}
</script>

<template>
  <div :class="$style.container">
    <img
      :class="$style.badge"
      src="@assets/images/badge_danger.svg"
      alt=">"
    >
    <span :class="$style.content">
      {{ number }}
    </span>

  </div>
</template>

<style scoped lang="scss" module>
@import '@design';

.badge {
  width: 1.6rem;
}

.container {
  position: relative;
  text-align: center;
}

.content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  color: $white;
  font-size: 0.9rem;
  font-weight: 500;
}
</style>
